import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { useBackgroundColor } from "../../../../hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "../../../../hooks/usePadding/usePadding.hook";
import { V1Props } from "./SpotsV1.interface";
import { useIconColor } from "./hooks/useIconColor/useIconColor.hook";
import Spot from "./components/Spot.component";
import { useAlignment } from "./hooks/useAlignment.hook";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./SpotsV1.module.scss";

const V1 = (props: V1Props) => {
    // Settings

    const { alignmentClass } = useAlignment(props.headerAlignment, S);
    const { backgroundColorClass, hasBackgroundColor, alternativeButtonTheme } = useBackgroundColor(
        props.backgroundColor
    );

    const { iconColorClassName } = useIconColor(props.iconColor);
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);

    return (
        <div
            className={cn(
                S.wrapper,
                backgroundColorClass,
                paddingClass,
                iconColorClassName,
                alignmentClass
            )}
        >
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    {/** Content */}
                    <div className={S.header}>
                        {/** Tagline */}
                        {props.tagline ? <span className={S.tagline}>{props.tagline}</span> : null}

                        {/** Title */}
                        {props.headline ? (
                            <DA_Title h2 tag={DA_TitleTag.H2} noMargin fullWidth>
                                {props.headline}
                            </DA_Title>
                        ) : null}

                        {/** Text */}
                        {props.text ? <DA_Text html={props.text} noPadding /> : null}
                    </div>

                    {/** Spots */}
                    <div className={S.items}>
                        {props.items?.map((item, index) => {
                            return (
                                <Spot
                                    {...item}
                                    alignment={props.itemAlignment}
                                    key={index}
                                    alternativeButtonTheme={alternativeButtonTheme}
                                />
                            );
                        })}
                    </div>
                </div>
            </DA_Container>
        </div>
    );
};
export default V1;
